import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./en/translation.json";
import arTranslation from "./ar/translation.json";

// Force language reload when switching
// Safe localStorage access check
const getSafeLanguage = () => {
  try {
    // Check if we are in a browser environment and NOT in Node.js
    // Accessing window.localStorage in Node 23+ triggers a SecurityError
    const isNode = typeof process !== 'undefined' && process.versions && process.versions.node;
    if (isNode) return 'en';

    if (typeof window !== 'undefined' && 'localStorage' in window) {
      return localStorage.getItem('i18nextLng') || 'en';
    }
  } catch (e) {
    // Fallback to 'en' if anything goes wrong
  }
  return 'en';
};

let currentLanguage = getSafeLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation: arTranslation },
    },
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;